import React from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  action,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="mb-5 flex items-center justify-center" style={{ width: '80px', height: '80px', borderRadius: '16px', background: '#E8E9EE' }}>
        {icon || (
          <svg
            className="h-10 w-10 text-text-tertiary"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
            />
          </svg>
        )}
      </div>
      <h3 className="text-lg font-semibold text-text-primary mb-1.5">{title}</h3>
      {description && (
        <p className="mb-6" style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 400, fontSize: '15px', lineHeight: '20px', textAlign: 'center', color: '#818384', maxWidth: '230px' }}>{description}</p>
      )}
      {action && (
        <button
          onClick={action.onClick}
          className="text-white font-bold active:scale-[0.97] transition-transform"
          style={{
            width: '240px',
            height: '44px',
            borderRadius: '12px',
            padding: '12px',
            fontSize: '15px',
            background: 'linear-gradient(90deg, #5370F5, #3657F0, #5370F5)',
          }}
        >
          {action.label}
        </button>
      )}
    </div>
  );
};
